<template>
    <!-- 大转盘 -->
    <div class="big-wheel"
        :style="{background: bgColor}">
        <!-- 抽奖主体区域，包括中奖记录滚动条，大转盘，非会员登录按钮 -->
        <div class="clear-fix lottery-wrapper"
            :style="{'background-image': `url(${bannerPic})`}">
            <!-- 获奖名单轮播--上方 -->
            <winner-list v-if="winnerScrollBarShow"
                :winnerList="winnerList"
                :activityObj="activityObj"></winner-list>
            <!-- 抽奖区域 -->
            <div class="banner awardRotateDisc">
                <div id="turnplate"
                    ref="turnplate"
                    :style="turnplateTop"
                    class="turnplate">
                    <!-- 转盘背景 -->
                    <img :src="drawWheelUrl"
                        alt=""
                        style="width: 100%;">
                    <canvas id="wheelcanvas"
                        ref="wheelcanvas"
                        class="item"
                        style="position: absolute; left: 0; top: 0;"></canvas>
                    <!-- 是会员，且可以抽奖 -->
                    <div v-if="!pointDrawFlag && activityStatus == 1 && canDrawFlag"
                        class="pointer"
                        @click="pointer()">
                        <img :src="drawBtnUrl"
                            alt="">
                        <div class="text-wrap">
                            <p style="font-size: 40px;">GO</p>
                            <div style="margin-top: -8px; font-size: 16px;">
                                <!-- 非积分抽奖 -->
                                <p v-if="drawType == 'initDraw' || drawType == 'orderDraw'">
                                    剩余{{ participateTimes> 99 ? '99+' : participateTimes }}次</p>
                                <!-- 积分抽奖 -->
                                <p v-if="drawType == 'pointDraw'">{{ drawPointConsumption }}{{ poinsOrDiamonds }}/次</p>
                            </div>
                        </div>
                    </div>
                    <!-- 不是会员，需要入会的情况 -->
                    <div v-if="pointDrawFlag"
                        class="member-login">
                        <img :src="grayPointer"
                            alt="">
                        <div class="text-wrap">
                            <p style="font-size: 40px;">GO</p>
                            <div style="margin-top: -8px; font-size: 16px;">
                                <p v-if="drawType == 'initDraw' || drawType == 'orderDraw'">
                                    剩余{{ participateTimes > 99 ? '99+' : participateTimes }}次</p>
                                <p v-if="drawType == 'pointDraw'">{{ drawPointConsumption }}{{ poinsOrDiamonds }}/次</p>
                            </div>
                        </div>
                        <!-- 跳转小程序 -->
                        <!-- 小程序内打开H5时 -->
                        <div v-if="miniprogramFlag || loginType == 'Alipay'"
                            class="member-login-btn"
                            @click="goHiHonorMiniProgram('index')"></div>
                        <!-- 微信打开H5时跳转 -->
                        <div v-if="!miniprogramFlag && loginType == 'wechat'"
                            class="member-login-btn">
                            <div class="wxOpenLaunchWeapp">
                                <wx-open-launch-weapp id="launch-btn"
                                    :username="hiHonorWxAppId"
                                    :env-version="envVersion"
                                    :path="`pages/tabBar/index/index.html?activityUrl=${encodeURIComponent(activityUrl)}`">
                                    <script type="text/wxtag-template">
                                        <div style="width: 1000px; height: 500px; display: block; opacity: 0; color: red; background: green;">打开小程序</div>
                                    </script>
                                </wx-open-launch-weapp>
                            </div>
                        </div>
                    </div>
                    <!-- 是会员，初始可抽奖或订单抽奖，没有抽奖机会 -->
                    <!-- 灰色抽奖按钮 -->
                    <div v-if="isNoChance"
                        class="pointer"
                        @click="noChanceFirst()">
                        <img :src="grayPointer"
                            alt="">
                        <div class="text-wrap"
                            style="top: 60%; color: #4A66FF; font-size: 18px;">
                            <p v-if="tips"
                                style="padding: 10px;width: 100px;margin: 0 auto;">{{ tips }}</p>
                            <p v-else>剩余<span class="count">0</span>次</p>
                        </div>
                    </div>
                    <!-- 是会员，积分抽奖场景，积分不足 -->
                    <div v-if="pointsNotEnough"
                        class="pointer"
                        @click="noPoints">
                        <img :src="drawBtnUrl"
                            alt="">
                        <div class="text-wrap">
                            <p style="font-size: 40px;">GO</p>
                            <div style="margin-top: -8px; font-size: 16px;">
                                <p>{{ drawPointConsumption }}{{ poinsOrDiamonds }}/次</p>
                            </div>
                        </div>
                    </div>
                    <!-- 活动未开始，活动已结束，活动已暂停 -->
                    <div v-if="!isRunning"
                        class="pointer"
                        @click="notRunningHandler">
                        <img :src="grayPointer"
                            alt="">
                        <div class="text-wrap"
                            style="top: 60%; color: #4A66FF; font-size: 18px;">
                            <p>{{ pointerText }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 我的奖品，中奖名单，按钮组件-->
        <reward-query :tigerLottery="tigerLottery"
            :miniprogramFlag="miniprogramFlag"
            :activityObj="activityObj"
            :miniType="activityObj.miniType"
            :loginType="loginType"
            @goWinnerList="goWinnerList"
            @goHiHonorMiniProgram="goHiHonorMiniProgram"></reward-query>
        <!-- 会员信息和中奖记录（共用） -->
        <member-and-winning :memberInfo="memberInfo"
            :myRecords="myRecords"
            :bigWheelActivityType="bigWheelActivityType"
            :tigerLottery="tigerLottery"
            :sectionThreeColor="sectionThreeColor"
            :pointsValue="pointsValue"
            @viewRecord="viewRecord"
            @nextStep="nextStep"></member-and-winning>
        <!-- 活动规则 -->
        <activity-rules :bigWheelRewardList="bigWheelRewardList"
            :bigWheelActivityType="bigWheelActivityType"
            :tigerLottery="tigerLottery"
            :sectionThreeColor="sectionThreeColor"
            :ruleDesci="ruleDesci"></activity-rules>
    </div>
</template>
<script>
import memberAndWinning from '../../components/member-and-winning.vue';
import rewardQuery from '../../components/reward-query.vue';
import activityRules from '../../components/activity-rules.vue';
import winnerList from '../../components/winner-list.vue';
import { config as configEnv } from '../../../../../../commons/config.js';
import { config } from '@/api/config.js';
import mixins from '../../mixin';
import { BigWheelConstants as BWC } from '../../common/global-variable';
export default {
  components: {
    memberAndWinning,
    rewardQuery,
    activityRules,
    winnerList,
  },
  mixins: [mixins],
  props: {
    isLoginFlag: Boolean,
    activityObj: Object,
    bannerPic: String,
    bgColor: String,
    drawWheelUrl: String,
    activityStatus: String,
    drawPointUrl: String,
    pointDrawFlag: Boolean,
    canDrawFlag: Boolean,
    drawType: String,
    turnplate: Object,
    participateTimes: Number,
    winnerList: Array,
    tigerLottery: Boolean,
    miniprogramFlag: Boolean,
    loginType: String,
    pointsValue: String,
    bigWheelActivityType: String,
    sectionThreeColor: String,
    memberInfo: Object,
    myRecord: Array,
    bigWheelRewardList: Array,
    ruleDesci: String,
    miniType: String,
    activityUrl: String,
    drawPointConsumption: Number,
    poinsOrDiamonds: String,
    userBase: Object,
    myRecords: Array,
    tips: String,
    // 用户的抽奖状态
    drawStatus: {
      type: String,
      default: '',
    },
    // 页面展示文案
    pageDisplayContent: {
      type: String,
      default: '',
    },
    // 弹窗提示语
    tipsMessage: {
      type: String,
      default: '',
    },
    // 弹框提示语对应code
    tipsMessageCode: {
      type: Number,
      default: null,
    },
    // 图片数据是否获取完成，用于执行绘制转盘的开始标志
    imgDataObtainDone: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    // 中奖信息滚动栏是否显示
    winnerScrollBarShow() {
      return this.activityObj.prizeWinningScrollFlag == BWC.prizeWinningScrollFlag.display && this.winnerList.length > 0;
    },
    // 大转盘奖品间隔颜色
    drawWheelSeparatorColor() {
      if (this.activityObj && this.activityObj.activityConfig && this.activityObj.activityConfig.drawWheelSeparatorColor) {
        return this.activityObj.activityConfig.drawWheelSeparatorColor;
      } else {
        return '#EAEAEA';
      }
    },
    turnplateTop() {
      return {
        'margin-top': this.winnerScrollBarShow ? '190px' : '248px',
      };
    },
    // 活动是否正在进行中
    isRunning() {
      return this.activityStatus === BWC.ActivityStatus.running;
    },
    // 抽奖指针显示的文案
    pointerText() {
      switch (this.activityStatus) {
        case BWC.ActivityStatus.notStarted:
          return '活动未开始';
        case BWC.ActivityStatus.paused:
          return '活动已暂停';
        case BWC.ActivityStatus.finished:
          return '活动已结束';
        default:
          return '';
      }
    },
    // 初始可抽奖、订单抽奖，是否没有抽奖机会
    isNoChance() {
      return (
        !this.pointDrawFlag &&
        this.activityStatus === BWC.ActivityStatus.running &&
        (this.drawType === BWC.DrawType.InitDraw || this.drawType === BWC.DrawType.OrderDraw || !this.drawType) &&
        !this.canDrawFlag
      );
    },
    // 积分抽奖，积分不足
    pointsNotEnough() {
      return !this.pointDrawFlag && this.activityStatus === BWC.ActivityStatus.running && this.drawType === BWC.DrawType.PointDraw && !this.canDrawFlag;
    },
    // 抽奖按钮图片URL
    drawBtnUrl() {
      if (this.drawStatus === BWC.status.exceedDailyTimes || this.drawStatus === BWC.status.exceedTotalTimes) {
        return this.grayPointer;
      } else {
        return this.drawPointUrl;
      }
    },
  },
  data() {
    return {
      envVersion: configEnv.env === 'pro' ? 'release' : 'trial',
      BWCInner: BWC,
      grayPointer: require('static/runtime/images/magic/award/zp_zz_hs.png'),
      hiHonorWxAppId:config.otherConfig.hiHonorWxAppId,
    };
  },
  watch: {
    // 图片数据加载完成，进行转盘的绘制，与初始化定位
    imgDataObtainDone(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          const promiseAll = [];
          const img = [];
          const imgArr = [...this.turnplate.imgs];
          const turnplateDom = document.getElementById('turnplate');
          for (let j = 0; j < imgArr.length; j++) {
            promiseAll[j] = new Promise((resolve) => {
              img[j] = new Image();
              img[j].setAttribute('id', 'img' + j);
              img[j].style.width = '100%';
              img[j].style.display = 'none';
              img[j].onload = function () {
                console.log('第' + j + '张图片加载完成');
                resolve(img[j]);
              };
              turnplateDom.appendChild(img[j]);
              img[j].src = imgArr[j];
            });
          }
          Promise.all(promiseAll)
            .then(() => {
              this.drawRouletteWheel();
              this.initLocation();
            })
            .catch((error) => {
              console.log(error);
            });
        });
      }
    },
  },
  mounted() {},
  methods: {
    // 绘制转盘
    drawRouletteWheel() {
      const canvas = document.getElementById('wheelcanvas');
      let devicePixelRatio = 1;
      if (window.devicePixelRatio) {
        devicePixelRatio = window.devicePixelRatio;
        // canvas.style.width = 442 + "px";
        // canvas.style.height = 442 + "px";
        canvas.height = 442 * devicePixelRatio;
        canvas.width = 442 * devicePixelRatio;
      }
      console.log('devicePixelRatio', devicePixelRatio);
      if (canvas.getContext) {
        console.log('this.turnplate', this.turnplate);
        //根据奖品个数计算圆周角度，即，单个区域块角度 = 2PI / 奖品数
        const arc = Math.PI / (this.turnplate.restaraunts.length / 2);
        const ctx = canvas.getContext('2d');
        // 设置水平和垂直方向的单位缩放比例
        // ctx.scale(devicePixelRatio, devicePixelRatio);
        //在给定矩形内清空一个矩形
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.lineWidth = 1 * devicePixelRatio;
        //font 属性设置或返回画布上文本内容的当前字体属性
        ctx.font = '16px Microsoft YaHei';
        for (let i = 0; i < this.turnplate.restaraunts.length; i++) {
          const angle = this.turnplate.startAngle + i * arc;
          //strokeStyle 属性设置或返回用于笔触的颜色、渐变或模式
          ctx.strokeStyle = this.drawWheelSeparatorColor;
          // ctx.strokeStyle = '#EAEAEA';
          // 清空子路径列表开始一个新路径的方法，即将画笔重置到原位
          ctx.beginPath();
          //arc(x,y,r,起始角,结束角,绘制方向) 方法创建弧/曲线（用于创建圆或部分圆）
          // 绘制扇形外边圆弧
          // ctx.arc(canvas.width / 2, canvas.height / 2, this.turnplate.outsideRadius * devicePixelRatio, angle, angle + arc, false);
          // 将起始点移动到指定位置
          ctx.moveTo(
            canvas.width / 2 + Math.cos(angle + arc) * this.turnplate.outsideRadius * devicePixelRatio,
            canvas.height / 2 + Math.sin(angle + arc) * this.turnplate.outsideRadius * devicePixelRatio
          );
          // 绘制扇形里边圆弧
          ctx.arc(canvas.width / 2, canvas.height / 2, this.turnplate.insideRadius * devicePixelRatio, angle + arc, angle, true);
          // 画线
          ctx.stroke();
          //锁画布(为了保存之前的画布状态)
          ctx.save();
          //----绘制奖品开始----
          ctx.fillStyle = '#E5302F';
          ctx.translate(
            canvas.width / 2 + Math.cos(angle + arc / 2) * this.turnplate.textRadius * devicePixelRatio,
            canvas.height / 2 + Math.sin(angle + arc / 2) * this.turnplate.textRadius * devicePixelRatio
          );
          //rotate方法旋转当前的绘图
          ctx.rotate(angle + arc / 2 + Math.PI / 2);
          const imgObj = document.getElementById('img' + i);
          ctx.drawImage(imgObj, -40 * devicePixelRatio, -10 * devicePixelRatio, 80 * devicePixelRatio, 80 * devicePixelRatio);
          //把当前画布返回（调整）到上一个save()状态之前
          ctx.restore();
          //----绘制奖品结束----
        }
      }
    },
    initLocation() {
      const awardNum = this.turnplate.restaraunts.length;
      // 大转盘停留位置控制，初始随机停留在某个奖品
      const item = Math.floor(Math.random() * awardNum);
      let angles = item * (360 / awardNum) - 360 / (awardNum * 2);
      if (angles < 270) {
        angles = 270 - angles;
      } else {
        angles = 360 - angles + 270;
      }
      $('#wheelcanvas').rotate({
        angle: 0,
        animateTo: angles,
        duration: 3000,
      });
    },
    goWinnerList() {
      this.$emit('goWinnerList');
    },
    goHiHonorMiniProgram(e) {
      this.$emit('goHiHonorMiniProgram', e);
    },
    pointer() {
      this.$emit('pointer');
    },
    noChanceFirst() {
      if (this.tipsMessageCode === 1501 || this.tipsMessageCode === 1502) {
        this.$emit('updateIsShowIdentityDialog');
      } else {
        this.noChance(this.tipsMessage);
      }
    },
    viewRecord(item) {
      this.$emit('viewRecord', item);
    },
    openGuide() {
      this.$emit('openGuide');
    },
    notRunningHandler() {
      if (this.activityStatus !== BWC.ActivityStatus.running) {
        let msg = '';
        switch (this.activityStatus) {
          case BWC.ActivityStatus.notStarted:
            msg = '活动未开始！';
            break;
          case BWC.ActivityStatus.paused:
            msg = '活动已暂停！';
            break;
          case BWC.ActivityStatus.finished:
            msg = '活动已结束！';
            break;
          default:
            return '';
        }
        this.$utils.tips.message('warning', msg);
      }
    },
    nextStep(link, type) {
      this.$emit('nextStep', link, type);
    },
  },
};
</script>
<style scoped lang='scss'>
.clear-fix::before,
.clear-fix::after {
  content: '';
  display: table;
  clear: both;
}
.big-wheel {
  width: 100vw;
  .lottery-wrapper {
    width: 100%;
    height: 173.333vw;
    // aspect-ratio: 750 / 1352;
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
}
.banner .turnplate .pointer,
.member-login {
  position: absolute;
  width: 32%;
  height: 39.07%;
  left: 34.3%;
  top: 26%;
  font-size: 14px;
  color: #fff;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}
.banner .turnplate {
  overflow: hidden;
  display: block;
  width: 100%;
  position: relative;
  padding-bottom: 10px;
  max-width: 420px;
  margin: 0 auto;
}
.pointer .text-wrap,
.member-login .text-wrap {
  position: absolute;
  left: 50%;
  top: 57%;
  transform: translate(-50%, -50%);
  width: 100%;
}
.awardRotateDisc {
  position: relative;
}
/* 大转盘样式 */
.banner {
  display: block;
  width: 95%;
  margin-left: auto;
  margin-right: auto;
}
.banner .turnplate canvas.item {
  width: 100%;
}
.banner .turnplate .pointer img,
.member-login img {
  width: 100%;
}

.tiger-btn-area {
  margin-top: 20px;
}
.list-wrap .container {
  background: #fff;
  border-radius: 10px;
  width: 96%;
  margin: 0 2%;
  /* margin-top: -8px; */
  padding: 20px 10px 20px;
  position: relative;
}
.activity-rules {
  display: block;
  width: 95%;
  margin-left: auto;
  margin-right: auto;
}
.blindBox-info-title {
  width: 100%;
  height: 20px;
  font-family: HYQiHei-FZS;
  font-size: 16px;
  font-weight: 400;
  position: relative;

  div {
    display: inline-block;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    &::before {
      content: '';
      width: 40px;
      height: 3px;
      position: absolute;
      top: 50%;
      left: -60px;
    }

    &::after {
      content: '';
      width: 40px;
      height: 3px;
      position: absolute;
      top: 50%;
      right: -60px;
    }
  }
}
.member-login-btn {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/lucky-draw/lucky-draw-page/big-wheel/big-wheel.vue